import i18n from '../../localization/i18n';

export const data = [
    {
        title: 'valuePropositionSection.list.title-1',
        Text: () => {
            return (
                <>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-1-1')}</li>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-1-2')}</li>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-1-3')}</li>
                </>
            );
        },
    },
    {
        title: 'valuePropositionSection.list.title-2',
        Text: () => {
            return (
                <>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-2-1')}</li>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-2-2')}</li>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-2-3')}</li>
                </>
            );
        },
    },
    {
        title: 'valuePropositionSection.list.title-3',
        Text: () => {
            return (
                <>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-3-1')}</li>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-3-2')}</li>
                </>
            );
        },
    },
    {
        title: 'valuePropositionSection.list.title-4',
        Text: () => {
            return (
                <>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-4-1')}</li>
                    <li>{i18n.t('valuePropositionSection.list.paragraph-4-2')}</li>
                </>
            );
        },
    },
];